import React, { Component, useState } from "react";
import "./App.css";
import AceParamBody from "./core/AceParamBody.js";
import ProfileSelector from "./core/ProfileSelector.js";
import * as vkbeautify from "vkbeautify";
import AceParameters from "./core/AceParameters";
import AceRequestBody from "./core/AceRequestBody";
import AceRequestBodyEditor from "./core/AceRequestBodyEditor";
import Servers from "./core/plugins/oas3/components/servers";
import curl from "./core/curl";
import { fromJS } from "immutable";
import SwaggerUi from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
import { executeRequest } from "./core/plugins/spec/actions";
import { mutatedRequestFor } from "./core/plugins/spec/selectors";
import { Header } from "./Header";
import { Footer } from "./Footer";

let profiles = {};

const ExecuteRequestServerOverride = function (system) {
  return {
    statePlugins: {
      spec: {
        actions: {
          executeRequest: (req) => {
            return executeRequest(req);
          },
        },
        selectors: {
          mutatedRequestFor: (state, path, method) => {
            return mutatedRequestFor(state, path, method);
          },
        },
      },
    },
  };
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      definitionList: {},
      definition: "documentations/swagger-PS-CA-CAFeX-A.yaml",
      currentDefinition: "",
    };
    this.updateDefinition = this.updateDefinition.bind(this);
    this.onChangeDefinition = this.onChangeDefinition.bind(this);
  }

  componentDidMount() {
    fetch("profilesList.json")
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.loadProfile(json);
      });

    fetch("definitionsList.json")
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.setState({ definitionList: json });
        this.setState({ currentDefinition: fromJS(Object.keys(json)).first() });

        const queryParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(queryParams.entries());
        if (params.spec in this.state.definitionList) {
          this.setState({ currentDefinition: params.spec });
          this.updateDefinition(params.spec);
        }
      });
  }

  componentDidUpdate() {
    SwaggerUi({
      domNode: document.getElementById("swagger"),
      url: this.state.definition,
      tryItOutEnabled: true,
      plugins: [
        {
          components: {
            parameters: AceParameters,
            ParamBody: AceParamBody,
            RequestBody: AceRequestBody,
            RequestBodyEditor: AceRequestBodyEditor,
            profileSelector: ProfileSelector,
            curl: curl,
            Servers: Servers,
          },
        },
        ExecuteRequestServerOverride,
      ],
    });
  }

  loadProfile(json) {
    for (let operationId in json) {
      profiles[operationId] = {};
      for (let type in json[operationId]) {
        profiles[operationId][type] = {};
        for (let profile in json[operationId][type]) {
          let file = json[operationId][type][profile];
          if (!file) {
            console.warn(`Profile "${profile}" for "${operationId}" (${type}) has no file path.`);
            continue;
          }
          fetch(file)
            .then((response) => {
              if (!response.ok) {
                console.warn(`Failed to load profile file: ${file} (${response.status})`);
                return null;
              }
              const contentType = response.headers.get("content-type");
              if (contentType && contentType.includes("text/html")) {
                console.warn(`Profile file returned HTML (not found): ${file}`);
                return null;
              }
              return response.text();
            })
            .then((data) => {
              let profileData =
                type === "json" ? vkbeautify.json(data) : vkbeautify.xml(data);
              profiles[operationId][type][profile] = profileData;
            });
        }
      }
    }
  }

  updateDefinition(v) {
    this.setState({ definition: this.state.definitionList[v] });
  }

  onChangeDefinition(v) {
    this.setState({ currentDefinition: v });
    this.updateDefinition(v);
  }

  render() {
    return (
      <div>
        <Header
          currentDefinition={this.state.currentDefinition}
          onChangeDefinition={this.onChangeDefinition}
          definitionList={this.state.definitionList}
        />

        <br />
        <br />
        <br />

        <div id="swagger" />

        <br />
        <br />
        <br />

        <Footer />
      </div>
    );
  }
}

export default App;
export { profiles };
